import type { CardLibraryStore, ManagedCardRecord } from "../schemas"
import { CardLibraryStoreSchema } from "../schemas"

export const CARD_LIBRARY_STORAGE_KEY = "craft-force.card-library"
export const CARD_LIBRARY_STORAGE_VERSION = 2

export const SEED_CARD_LIBRARY: CardLibraryStore = [
  {
    card: {
      id: "card_red_brawler",
      kind: "authored_unit",
      name: "Red Brawler",
      primaryColor: "red",
      secondaryColor: "yellow",
      stats: {
        attack: 4,
        health: 2,
      },
      selectedSkills: [
        {
          skillId: "swift",
        },
      ],
      authoredCostInputs: {
        skillCostDelta: 1,
        nonExhaustSurcharge: 0,
        selfDestructSurcharge: 0,
        secondaryColorSurcharge: 0.5,
      },
      derivedCost: 6,
    },
    updatedAt: "2026-03-20T14:00:00.000Z",
    deckUsageCount: 3,
  },
  {
    card: {
      id: "card_blue_scout",
      kind: "authored_unit",
      name: "Blue Scout",
      primaryColor: "blue",
      stats: {
        attack: 2,
        health: 3,
      },
      selectedSkills: [
        {
          skillId: "scout",
        },
        {
          skillId: "shield",
        },
      ],
      authoredCostInputs: {
        skillCostDelta: 2,
        nonExhaustSurcharge: 0,
        selfDestructSurcharge: 0,
        secondaryColorSurcharge: 0,
      },
      derivedCost: 5,
    },
    updatedAt: "2026-03-19T19:30:00.000Z",
    deckUsageCount: 1,
  },
  {
    card: {
      id: "card_green_patcher",
      kind: "authored_unit",
      name: "Green Patcher",
      primaryColor: "green",
      secondaryColor: "blue",
      stats: {
        attack: 1,
        health: 5,
      },
      selectedSkills: [
        {
          skillId: "repair",
        },
      ],
      authoredCostInputs: {
        skillCostDelta: 1,
        nonExhaustSurcharge: 0,
        selfDestructSurcharge: 0,
        secondaryColorSurcharge: 0.5,
      },
      derivedCost: 8,
    },
    updatedAt: "2026-03-18T08:45:00.000Z",
    deckUsageCount: 2,
  },
  {
    card: {
      id: "card_yellow_marshal",
      kind: "authored_unit",
      name: "Yellow Marshal",
      primaryColor: "yellow",
      stats: {
        attack: 3,
        health: 4,
      },
      selectedSkills: [
        {
          skillId: "guard",
        },
        {
          skillId: "rally",
        },
      ],
      authoredCostInputs: {
        skillCostDelta: 3,
        nonExhaustSurcharge: 0,
        selfDestructSurcharge: 0,
        secondaryColorSurcharge: 0,
      },
      derivedCost: 8,
    },
    updatedAt: "2026-03-17T16:20:00.000Z",
    deckUsageCount: 4,
  },
  {
    card: {
      id: "card_purple_intruder",
      kind: "authored_unit",
      name: "Purple Intruder",
      primaryColor: "purple",
      secondaryColor: "red",
      stats: {
        attack: 3,
        health: 2,
      },
      selectedSkills: [
        {
          skillId: "sneak",
        },
        {
          skillId: "shift",
        },
      ],
      authoredCostInputs: {
        skillCostDelta: 3,
        nonExhaustSurcharge: 0,
        selfDestructSurcharge: 0,
        secondaryColorSurcharge: 0.5,
      },
      derivedCost: 7,
    },
    updatedAt: "2026-03-16T10:10:00.000Z",
    deckUsageCount: 2,
  },
]

export const EMPTY_CARD_LIBRARY: CardLibraryStore = []
export const CardLibraryStateSchema = CardLibraryStoreSchema

export function buildDuplicatedCardRecord(
  source: ManagedCardRecord,
  existingCards: CardLibraryStore,
): ManagedCardRecord {
  const nextName = getNextDuplicateName(
    source.card.name,
    existingCards.map((record) => record.card.name),
  )
  const timestamp = new Date().toISOString()

  return {
    ...source,
    card: {
      ...source.card,
      id: createCardId(nextName),
      name: nextName,
    },
    remoteSyncFailedAt: undefined,
    remoteSyncedAt: undefined,
    updatedAt: timestamp,
    deckUsageCount: 0,
  }
}

export function createCardId(name: string): string {
  const slug = name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/gu, "_")
    .replace(/^_+|_+$/gu, "")

  return `card_${slug || "custom"}_${Date.now().toString(36)}`
}

export function getNextDuplicateName(
  sourceName: string,
  existingNames: readonly string[],
): string {
  const trimmedSourceName = sourceName.trim()
  const lowerCaseNames = new Set(
    existingNames.map((name) => name.toLowerCase()),
  )

  if (!lowerCaseNames.has(trimmedSourceName.toLowerCase())) {
    return trimmedSourceName
  }

  let duplicateIndex = 2

  while (
    lowerCaseNames.has(`${trimmedSourceName} ${duplicateIndex}`.toLowerCase())
  ) {
    duplicateIndex += 1
  }

  return `${trimmedSourceName} ${duplicateIndex}`
}
